import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=1bed307c&scoped=true"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"
import style0 from "./ShowForm.vue?vue&type=style&index=0&id=1bed307c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed307c",
  null
  
)

export default component.exports